export default __webpack_public_path__ + "static/media/Gilroy-Light.cc7ab55d.woff";